import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=4704d2e5"
import script from "./breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./breadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4704d2e5')) {
      api.createRecord('4704d2e5', component.options)
    } else {
      api.reload('4704d2e5', component.options)
    }
    module.hot.accept("./breadcrumbs.vue?vue&type=template&id=4704d2e5", function () {
      api.rerender('4704d2e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/breadcrumbs.vue"
export default component.exports